module.exports = __webpack_public_path__ + "img/applications.8aac2f88.png";